export default __webpack_public_path__ + "static/media/Flag_of_Ukraine.11e07f6c.svg";